import api from "./Api";

class PedidoItemDetTipoEmbalagemService {
  GetPedidoItemDetTipoEmbalagem(payload) {
    return api
      .get("/v1/pedidoItemDetTipoEmbalagem/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostPedidoItemDetTipoEmbalagem(payload) {
    return api
      .post("/v1/pedidoItemDetTipoEmbalagem/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutPedidoItemDetTipoEmbalagem(payload) {
    return api
      .put("/v1/pedidoItemDetTipoEmbalagem/", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeletePedidoItemDetTipoEmbalagem(payload) {
    return api
      .delete("/v1/pedidoItemDetTipoEmbalagem/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidoItemDetTipoEmbalagemOData(payload) {
    return api
      .get("/OData/PedidoItemDetTipoEmbalagem" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PedidoItemDetTipoEmbalagemService();
